import React,{} from 'react'
import { Paper } from '@mui/material'
import './Display.css'



export interface displayProps{
    data: number
    title?:string
    unit?:string
    size?:string
}

function DisplayBox(props:displayProps){
const {data, title, unit, size} = props
console.log("DisplayBox data:",data)
if (data === undefined || data === null){
    return(
        <div className={`Number-Box`}>
            <h2 style={{color:'white'}}>{title}</h2>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'center'} }>
                <h1 style={{color:'white'}}>No Data</h1>
            </div>
        </div>
    )
}
return(
    
    <div className={`Number-Box`}>
         <h2 style={{color:'white'}}>{title}</h2>
     <div style={{display:'flex', flexDirection:'row', justifyContent:'center'} }>
        <h1 style={{color:'white'}}>{data.toFixed(2)} {unit}</h1>
     </div>
    </div>

   
    

)
}

export default DisplayBox